import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { NAV_LINKS, COMPANY } from "@/lib/site";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 18);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass py-3" : "py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-2 group"
        >
          <span className="relative inline-flex w-8 h-8 items-center justify-center bg-[#E63946]">
            <span className="font-heading font-black text-white text-lg leading-none">
              M
            </span>
            <span className="absolute -bottom-1 -right-1 w-2 h-2 bg-white"></span>
          </span>
          <span className="font-heading font-black tracking-tighter text-xl">
            Motorie
            <span className="text-[#E63946]">Ricambi</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-${link.label.toLowerCase()}`}
              className="px-4 py-2 text-sm text-zinc-300 hover:text-white uppercase tracking-widest font-medium transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            data-testid="header-call-btn"
            className="hidden lg:flex items-center gap-2 text-zinc-300 hover:text-white text-sm font-mono transition-colors"
          >
            <Phone size={14} className="text-[#E63946]" />
            {COMPANY.phone}
          </a>
          <a
            href="#preventivo"
            data-testid="header-cta-btn"
            className="px-5 py-3 bg-[#E63946] hover:bg-[#c81d25] text-white font-bold uppercase tracking-widest text-xs transition-colors"
          >
            Preventivo
          </a>
        </div>

        <button
          aria-label="Apri menu"
          data-testid="header-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-white"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="header-mobile-menu"
          className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-zinc-300 hover:text-white uppercase tracking-widest text-sm border-b border-white/5"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#preventivo"
              onClick={() => setOpen(false)}
              className="mt-3 px-5 py-3 bg-[#E63946] text-white text-center font-bold uppercase tracking-widest text-xs"
            >
              Richiedi Preventivo
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
